import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TenderCatalogModelStatuses } from '~/models/tenderCatalogModel';


@Component({
    selector: 'wep-ag-grid-cell-renderer-market-admin-tender-status',
    templateUrl: './status.html',
    host: { 'class' : 'wep-ag-grid-cell-renderer wep-ag-grid-cell-renderer-market wep-ag-grid-cell-renderer-market-admin-tender-status' },
    styleUrls: ['./status.scss']
})

export class AgGridCellRendererMarketAdminTenderStatusComponent implements ICellRendererAngularComp {
    public params: any;

    public agInit(params: any) : void {
        this.params = params;
    }

    public refresh() : boolean {
        return false;
    }

    public getCircleClass(value:TenderCatalogModelStatuses) : string {
        if(value === TenderCatalogModelStatuses.Draft) {
            return 'circle--upcoming';
        }
        else if(value === TenderCatalogModelStatuses.Open) {
            return 'circle--live';
        }
        else if(value === TenderCatalogModelStatuses.Closed) {
            return 'circle--closed';
        }
    }
}
